import {
  NARRATIVE_TYPES,
  NARRATIVE_TYPES_ARRAY,
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
} from "posts/constants";
import styled, { css } from "styled-components";
import { COLORS } from "utils/styles";
import Link from "next/link";
import { getAudienceSlug, getNarrativeSlug } from "posts/constants";
import * as Sentry from "@sentry/node";

const getColorFromAudienceValue = (value) => {
  const key = Object.keys(AUDIENCE_TYPES).reduce((acc, val) => {
    if (value === AUDIENCE_TYPES[val]) {
      return val;
    }
    return acc;
  }, "");
  if (!key) {
    return "inherit";
  }
  return COLORS[key];
};
const getColorFromNarrativeValue = (value) => {
  const key = Object.keys(NARRATIVE_TYPES).reduce((acc, val) => {
    if (value === NARRATIVE_TYPES[val]) {
      return val;
    }
    return acc;
  }, "");
  if (!key) {
    return "inherit";
  }
  return COLORS[key];
};

const Wrapper = styled.strong`
  ${({ isAudience, isNarrative }) => {
    if (isAudience || isNarrative) {
      return css`
        > a {
          font-weight: 400;
          font-family: "mabry-regular" !important;
          border-bottom: 0 none !important;
        }
      `;
    }
  }}

  ${({ isAudience, value }) => {
    if (isAudience) {
      const color = getColorFromAudienceValue(value);
      return css`
        & > a {
          padding: 0.1rem 0.3rem;
          background: ${color};
          position: relative;
          color: ${COLORS.BLACK};
          z-index: 0;
          font-size: 11pt;
          border-radius: 5px;
        }
      `;
    }
  }}
  
  ${({ isNarrative, value }) => {
    if (isNarrative) {
      const color = getColorFromNarrativeValue(value);
      return css`
        & > a {
          padding: 0.2rem 0.4rem;
          background: ${color};
          position: relative;
          color: ${COLORS.BLACK};
          z-index: 0;
          font-size: 11pt;
          border-radius: 5px;
        }
      `;
    }
  }}
`;

export default function MarkdownStrong({ node, children, ...props }) {
  if (!children) {
    return null;
  }
  let val = children[0];

  if (typeof val === "object") {
    try {
      val = children[0].props.children[0];
    } catch (err) {
      Sentry.captureException(err);
    }
  }
  const isAudience = val.trim
    ? AUDIENCE_TYPES_ARRAY.includes(val.trim())
    : false;
  const isNarrative = val.trim
    ? NARRATIVE_TYPES_ARRAY.includes(val.trim())
    : false;

  if (isAudience) {
    return (
      <Wrapper isAudience={true} isNarrative={false} value={val} {...props}>
        <Link href={`/audiences/${getAudienceSlug(val)}`}>{children[0]}</Link>
      </Wrapper>
    );
  }

  if (isNarrative) {
    return (
      <Wrapper isAudience={false} isNarrative={true} value={val} {...props}>
        <Link href={`/narratives/${getNarrativeSlug(val)}`}>{children[0]}</Link>
      </Wrapper>
    );
  }

  return <strong {...props} />;
}
